import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f024efb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-col-centered" }, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_2 = { class: "top-content" }
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = {
  key: 0,
  class: "comment-display-style"
}
const _hoisted_5 = { class: "flex-col-centered" }
const _hoisted_6 = {
  key: 0,
  class: "submit-btn",
  type: "submit"
}

import { computed, ref, watch } from "vue";
import "@vuepic/vue-datepicker/dist/main.css";
import Popup from "./Popup.vue";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";
import useSpinnerPopup from "@/services/composables/SpinnerPopup";
import { insuranceClaims } from "@/services/network";
import IInsuranceForm from "@/Interfaces/InsuranceClaims/IInsuranceClaimsForm";
import DateIgnoreTime from "@/types/DateIgnoreTime";
import { authService } from "@/auth/authSingleton";


export default /*#__PURE__*/_defineComponent({
  __name: 'InsuranceCommentPopUp',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const newCommentInsertedPopUp = computed(()=>{
    if(selectedRow.value?.comments == null || selectedRow.value?.comments == ""){
        return true
    }else{
        return false
    }
});
const selectedRow = computed({
    get() {
        return props.modelValue
    },
    set(val) {
        emits('update:modelValue', val);
    }
})
const editCommentButtonState = ref(false);

const itemBeingEdited = computed(()=>{
    if(newCommentInsertedPopUp.value == true){
        return false
    }
    if(editCommentButtonState.value == false){
        return true
    }
    else{
        return false
    }
});
const emits = __emit;
const working = ref(false);
const selectedRowCopy = ref<Partial<IInsuranceForm>>({});

watch(selectedRow, (val)=>{
    if (val) {
        selectedRowCopy.value = Object.assign({}, val);
    }
});
function closeChild(){
    selectedRow.value = undefined;
    editCommentButtonState.value = false;
}

async function EditInsuranceClaim() {
    if(working.value) return;    
    const closeSpinner = useSpinnerPopup().show();
    try{
        if(selectedRowCopy.value.comments === selectedRow.value?.comments){
            useNotifierWithErrFormatter().warn({msg: "Comment was not changed"});
        }
        else{
            working.value=true
            let postRequest: IInsuranceForm = {
                market: selectedRowCopy.value?.market ?? 'GB',
                contractId: selectedRowCopy.value?.contractId || '',
                paymentDate: new DateIgnoreTime(selectedRowCopy.value?.paymentDate),
                caseReferenceId: selectedRowCopy.value?.caseReferenceId, 
                fullAmount: selectedRowCopy.value?.fullAmount, 
                excessAmount: selectedRowCopy.value?.excessAmount,
                companyName: selectedRowCopy.value?.companyName, 
                companyVatId: selectedRowCopy.value?.companyVatId, 
                companyLocation: selectedRowCopy.value?.companyLocation,
                comments: selectedRowCopy.value?.comments,
                isCompleted: selectedRowCopy.value?.isCompleted,
                userEmail: authService.getEmailAddress(), 
                ticketId: selectedRowCopy.value?.ticketId
            };        
            await insuranceClaims.put(postRequest)
            useNotifierWithErrFormatter().success({ msg: "Comment successfully edited." });
            emits("confirm");
            closeChild()
        }
        
    }catch(error){
        useNotifierWithErrFormatter().error({error});
    }
    closeSpinner()
    working.value=false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popup, {
    "model-value": !!selectedRow.value,
    title: newCommentInsertedPopUp.value ? `Add Comment For Insurance Claim: ${selectedRow.value?.contractId}` : `Comment For Insurance Claim: ${selectedRow.value?.contractId}`,
    hasClose: "",
    "onUpdate:modelValue": closeChild
  }, {
    contents: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          onSubmit: _withModifiers(EditInsuranceClaim, ["prevent"])
        }, [
          _createElementVNode("div", null, [
            (editCommentButtonState.value == false && newCommentInsertedPopUp.value == false)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(selectedRowCopy.value.comments), 1))
              : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                  key: 1,
                  class: "form-input textarea-input invalid-input",
                  maxlength: "4096",
                  spellcheck: "true",
                  rows: "4",
                  id: "comments",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedRowCopy.value.comments) = $event))
                }, null, 512)), [
                  [_vModelText, selectedRowCopy.value.comments]
                ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            (itemBeingEdited.value == false)
              ? (_openBlock(), _createElementBlock("button", _hoisted_6, _toDisplayString(newCommentInsertedPopUp.value? 'Add Comment':'Confirm Edit'), 1))
              : _createCommentVNode("", true),
            (itemBeingEdited.value == true)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "submit-btn",
                  type: "submit",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (editCommentButtonState.value = true))
                }, " Edit Comment "))
              : _createCommentVNode("", true)
          ])
        ], 40, _hoisted_3)
      ])
    ]),
    _: 1
  }, 8, ["model-value", "title"]))
}
}

})